import { useCallback, useState } from "react"

interface UseControlledReturn<TValue> {
    value: TValue
    setValue: (newValue: TValue) => void
    isControlled: boolean
}

function useControlled<TValue>(
    controlledValue: TValue | undefined,
    defaultValue: TValue
): UseControlledReturn<TValue> {
    const isControlled = controlledValue !== undefined
    const [internalValue, setInternalValue] = useState<TValue>(defaultValue)

    const value = isControlled ? controlledValue : internalValue

    const setValue = useCallback((newValue: TValue) => {
        if (!isControlled) {
            setInternalValue(newValue)
        }

    }, [isControlled])

    return { value, setValue, isControlled }
}

export { useControlled }